// Events for amplitude tracking
export enum AdminAwardTrackingEvent {
	// Index page actions
	CreateAward = 'Admin Index Create Award',
	SelectAward = 'Admin Select an Award',
	ReviewPosts = 'Admin Review Award Posts',
	AwardSummary = 'Admin Click Review Award Recognition Activity',
	EditAward = 'Admin Edit Award',
	ReviewArchivedAwards = 'Admin Review Archived Awards',
	ApproveAward = 'Admin Index Approve Award',
	ChoosePending = 'Admin Select Pending Award',
	IndexPaginate = 'Admin Awards Index Paginate',
	SortAwards = 'Admin Index Sort Awards',
	IndexDeactivateAward = 'Admin Index Deactivate Award Modal',

	// Archived index page actions
	ArchivedSelectAward = 'Admin Archived Index Select Award',
	ArchivedEditAward = 'Admin Archived Index Edit Award',
	ArchivedDeleteAward = 'Admin Archived Index Delete Award Modal',
	ArchivedPaginate = 'Admin Archived Awards Index Paginate',
	ArchivedSortAwards = 'Admin Archived Index Sort Awards',
	ArchivedReviewPosts = 'Admin Archived AwardsIndex Review Posts',

	// Modals
	DeactivateAward = 'Admin Deactivate Award',
	ReactivateAward = 'Admin Reactivate Award',
	DeleteAward = 'Admin Delete Award',

	// Form actions
	RecognitionPostPreview = 'Admin Award Form Open Recognition Post Preview',
	SetPointsBudgetMode = 'Admin Award Form Set Points Budget',
	SetApprovalProcess = 'Admin Award Form Set Approval Process',
	ToggleVisibilityEditable = 'Admin Award Form Toggle Visibility Editable',
}
